import { render, staticRenderFns } from "./MyParts.vue?vue&type=template&id=59c6818f&"
import script from "./MyParts.vue?vue&type=script&lang=js&"
export * from "./MyParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports